import { serviceRoleApi } from 'api';
import { ServiceAgreementV2 } from 'pco-product-service-internal-consumer';

export const callDeactivateServiceRole = async (serviceRoleUid: string): Promise<ServiceAgreementV2> => {
  return await serviceRoleApi.deactivateOrDeleteServiceRole({ serviceRoleUid });
};
